<script setup lang="ts" generic="T">
import { useVModel } from '@vueuse/core';
import isEqual from 'lodash/isEqual';
import { computed } from 'vue';

import FormControlsWrapper from '@/components/base/form/FormControlsWrapper.vue';
import Radio from '@/components/base/form/Radio.vue';

const emit = defineEmits(['update:modelValue']);

const props = defineProps<{
  disabled?: boolean;
  appearanceNone?: boolean;
  id?: string;
  modelValue?: T;
  name: string;
  position?: 'first' | 'last' | 'middle';
  value: T;
}>();

const selection = useVModel(props, 'modelValue', emit);
const isSelected = computed(() => isEqual(selection.value, props.value));
</script>

<template>
  <FormControlsWrapper
    :appearanceNone="appearanceNone"
    :disabled="disabled"
    :position="position"
    :selected="isSelected"
    @click.self="selection = value"
  >
    <div v-if="disabled" class="absolute inset-0 w-full h-full bg-true-gray-100/90">
      <slot name="disabled" />
    </div>
    <div class="flex justify-between" @click.self="selection = value">
      <Radio
        v-model="selection"
        class="text-base"
        :appearanceNone="appearanceNone"
        :class="{ grow: !$slots.right }"
        :disabled="disabled"
        :id="id"
        :name="name"
        :value="value"
      >
        <slot />
      </Radio>
      <slot name="right" />
    </div>
    <slot name="bottom" />
  </FormControlsWrapper>
</template>
